export default "__VITE_ASSET__El1R6h0G__"